import React from 'react'
import PNavbar from '../Components/Park/PNavbar/PNavbar'
import PHeader from "../Components/Park/PHeader/PHeader"
import Residency from '../Components/Park/Residency/Residency'
import PremiumResidences from "../Components/Park/PremiumResidences/Premiumresidences"
import ResidencePlan from "../Components/Park/ResidencePlan/ResidencePlan"
import Services from '../Components/Park/Services/Services'
import Amenities from '../Components/Park/Amenities/Amenities'
import Surrounding from '../Components/Park/Surrounding/Surrounding'
import Footer from '../Components/Park/Footer/Footer'

const Park = () => {
  return (
    <>
      <PNavbar/>
      <PHeader />
      <Residency />
      <PremiumResidences />
      <ResidencePlan />
      <Services />
      <Amenities />
      <Surrounding />
      <Footer />
    </>
  )
}

export default Park